import { getPageTitle } from '@/navigation/nav-items';
import { REPORTS } from '@/reports/catalog';

function titleFromSlug(pathname: string): string {
  const leaf = pathname.split('/').filter(Boolean).pop() ?? pathname;
  return leaf
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

/** Human page name for a saved-view pathname (catalog / nav, not a URL slug). */
export function savedFilterPageLabel(pathname: string): string {
  const report = REPORTS.find((r) => r.path === pathname);
  if (report) return report.name;

  const title = getPageTitle(pathname);
  if (title && title !== 'Reports') return title;

  if (pathname.startsWith('/reports/') && pathname.length > '/reports/'.length) {
    return titleFromSlug(pathname);
  }
  return title || pathname;
}
